import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { cartActions } from '../../reducers/storeCart';
import * as types from '../../types';
import Checkbox from '../Checkbox';
import styles from './HardwareFirstGiftToggle.module.scss';

/** "this is a gift" card in the cart rail. the flag lives on the store cart so it survives reload. */
export default function HardwareFirstGiftToggle() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isGift = useSelector((state: types.AppState) => !!state.storeShop.cart.isGift);

  return (
    <Checkbox
      className={styles.toggle}
      checked={isGift}
      onChange={(checked) => dispatch(cartActions.setIsGift(checked))}
      label={
        <span className={styles.text}>
          <span className={styles.title}>{t('hardware_first_gift_toggle_label')}</span>
          <span className={styles.sub}>{t('hardware_first_gift_toggle_sub')}</span>
        </span>
      }
    />
  );
}
